window.addEventListener("load", function () {
  const slickSliderSettings = {
    onlyDots: {
      arrows: false,
      dots: true,
    },
    onlyArrows: {
      arrows: true,
      dots: false,
      prevArrow:
        '<div class="slick-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14,19c-0.3,0-0.5-0.1-0.7-0.3l-6-6c-0.4-0.4-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L9.4,12l5.3,5.3c0.4,0.4,0.4,1,0,1.4C14.5,18.9,14.3,19,14,19z"/></svg></div>',
        // '<div class="slick-prev"><<svg><use xlink:href="/assets/img/sprite.svg#chevron-left"></svg></div>',
      nextArrow:
        '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9,19c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l5.3-5.3L8.3,6.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l6,6c0.4,0.4,0.4,1,0,1.4l-6,6C9.5,18.9,9.3,19,9,19z"/></svg></div>',
        // '<div class="slick-next"><<svg><use xlink:href="/assets/img/sprite.svg#chevron-right"></svg></div>',
    },
  };

  if ($("#main-page")) {
    const vm = new Vue({
      el: "#main-page",
      data: {
        scheduleDaysCount: "",
      },
    });

    // баннер на главной странице
    if ($(".banner__slider"))
      $(".banner__slider").slick({
        ...slickSliderSettings.onlyDots,
        ...{
          responsive: [
            {
              breakpoint: 768,
              settings: {
                dots: false,
              },
            },
          ],
        },
      });

    if ($(".service-slider"))
      $(".service-slider").slick({
        ...slickSliderSettings.onlyDots,
        ...{
          slidesToShow: 6,
          slidesToScroll: 6,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
              },
            },
            {
              breakpoint: 820,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
          ],
        },
      });

    if ($(".events-slider"))
      $(".events-slider").slick(slickSliderSettings.onlyArrows);

    if ($(".banner__advertising-slider"))
      $(".banner__advertising-slider").slick(slickSliderSettings.onlyArrows);
  }

  if ($("#register-page")) {
    const vm = new Vue({
      el: "#register-page",
      data: {
        showCountVariants: [10, 20, 30, 40, 50],
        selectedShowCountVariantsId: 0,

        viewTypes: ["list", "grid"],
        selectedViewType: "list",

        organizationLevelVariants: [
          "Все",
          "Федеральный",
          "Субъекты РФ",
          "Муниципальный",
        ],
        selectedOrganizationLevelVariantId: 0,


        regionVariants: [
          "Все регионы РФ",
          "Татарстан",
          "Башкортостан",
          "Москва",
          "Санкт-Петербург",
        ],
        selectedRegionVariantsId: 0,

        subjectsSONKOVariants: ["Все субъекты", "1", "2", "3", "4"],
        selectedSubjectsSONKOVariantsId: 0,

        isFilterBlockOpened: false,
        isHandbookActive: false,

        statusTabs: [
          "Все",
          "Планируемые",
          "На рассмотрении",
          "Ожидает начала торгов",
          "Торговые сессии",
          "Подведение торогов",
          "Приостановленные",
          "Отмененные",
          "Завершенные",
        ],
        selectedStatusTabId: 0,
      },
      watch: {
        isHandbookActive: function(cur) {
          this.$nextTick(() => {
            $(".modal table").colResizable({
              resizeMode: 'overflow',
              partialRefresh:true
            });
          });
        }
      },
      mounted() {
        $(".js-vue-datepicker").datepicker();
      }
    });

    $("body").on("click", '[data-el="js-open-statuses"]', function (e) {
      e.preventDefault();
      $statusesBlock = $(this).siblings('[data-el="js-statuses-block"]');
      $statusesBlock.toggleClass("active");
      $('[data-el="js-statuses-block"]')
        .not($statusesBlock)
        .removeClass("active");
    });

    $("body").on("click", '[data-el="js-open-more-function"]', function (e) {
      e.preventDefault();
      $functionBlock = $(this).siblings('[data-el="js-more-function-block"]');
      $functionBlock.toggleClass("active");
      $('[data-el="js-more-function-block"]')
        .not($functionBlock)
        .removeClass("active");

      let rect = $(this)[0].getBoundingClientRect();
      if ($functionBlock.hasClass('fixed')) {
        $functionBlock.css({'position' : 'fixed', 'z-index' : 5, 'top' : rect.bottom+'px', 'right' : window.innerWidth - rect.right+'px' });

        
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleScroll);

        window.addEventListener('scroll', () => {
          handleScroll($(this), $functionBlock);
        })
        window.addEventListener('resize', () => {
          handleScroll($(this), $functionBlock);
        })

      }
      
      function handleScroll($this, $functionBlock) {
        rect = $this[0].getBoundingClientRect();
          $functionBlock.css({'position' : 'fixed', 'z-index' : 1, 'top' : rect.bottom+'px', 'right' : window.innerWidth - rect.right+'px' });
      }

    });

    $("body").on(
      "click",
      '[data-el="js-open-setting-table-view"]',
      function (e) {
        e.preventDefault();
        $(this)
          .siblings('[data-el="js-setting-table-view"]')
          .toggleClass("active");
      }
    );
  }

  if ($("#documents-page").length) {
    const vm = new Vue({
      el: "#documents-page",
    });
    
    new AsideMenu(".aside-menu");
  }

});
